<div class="onsight-form-input-select" *ngIf="myClass !== null" >
  <label>{{ myClass.langBase + label | translatePipe }}</label>
  <mat-form-field appearance="fill" *ngIf="showList" >
    <mat-select (selectionChange)="onChange($event, name)" class="form-control" placeholder="{{ 'commons.forms.select' | translatePipe }}"
                [(ngModel)]="myClass.model[name]" name="{{ name }}" [required]="required">
      <input placeholder="{{ 'commons.filter' | translatePipe }}" class="select-search" (keyup)="onKey($event, 'locationName')">
      <mat-option *ngIf="!filter" [value]="" [disabled]="true">{{ 'commons.forms.select' | translatePipe }}</mat-option>
      <mat-option *ngIf="filter" [value]="0">{{ 'commons.filters.all' | translatePipe }}</mat-option>
      <mat-option [value]="l.locationID" *ngFor="let l of list">{{ l.locationName }}</mat-option>
    </mat-select>
  </mat-form-field>
  <p class="btn-text" (click)="createLocation = true">Agregar Ubicación</p>
  <google-map
    *ngIf="positionReady"
    class="map"
    height="400px"
    width="100%"
    [center]="center"
    [zoom]="zoom">
    <map-marker [position]="center"
                [options]="markerOptions"></map-marker>
  </google-map>
</div>
<div class="pop-up" *ngIf="createLocation">
  <div class="pop-up-bg" (click)="close()"></div>
  <div class="pop-up-content">
    <div class="card card-popup-form">
      <form (ngSubmit)="sendForm($event)" ngNativeValidate>
        <div class="card-header">
          <h1 class="title">{{ title | translatePipe }}</h1>
          <img class="img-close" src="{{ imageClose }}" alt="img_close" (click)="close()">
        </div>
        <div class="card-body">
          <div class="row" *ngIf="fieldForms.length > 0">
            <div *ngFor="let ff of fieldForms"
                 class="{{ ff.cols }}">
              <app-field-form
                *ngIf="(ff.name === 'position' && positionReload) || ff.name !== 'position'"
                [myClass]="service.modelClass"
                [centerLatLng]="center"
                [name]="ff.name"
                [model]="service.modelClass.model"
                [cellType]="ff.cellType"
                [label]="ff.label"
                [disabled]="ff.disable"
                (changeAction)="onChange($event, ff.name)"
                [required]="ff.required"
                [multiple]="ff.multiple"></app-field-form>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="row">
            <div class="col-12">
              <p class="error" *ngIf="error">{{ 'commons.forms.errorFields' | translatePipe }}<b *ngFor="let error of errors">{{ service.modelClass.langBase + error | translatePipe }}</b></p>
            </div>
            <div class="col-12 col-md-6"></div>
            <div class="col-12 col-md-3"><app-button [type]="'button'" [classCss]="'btn-cancel'" (action)="close()" [text]="'commons.cancel'"></app-button></div>
            <div class="col-12 col-md-3"><app-button [type]="'submit'" [classCss]="''" [text]="'commons.accept'"></app-button></div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
